import { render, staticRenderFns } from "./Copy.vue?vue&type=template&id=fa1f2dfa&scoped=true&"
import script from "./Copy.vue?vue&type=script&lang=js&"
export * from "./Copy.vue?vue&type=script&lang=js&"
import style0 from "./Copy.vue?vue&type=style&index=0&id=fa1f2dfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa1f2dfa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fa1f2dfa')) {
      api.createRecord('fa1f2dfa', component.options)
    } else {
      api.reload('fa1f2dfa', component.options)
    }
    module.hot.accept("./Copy.vue?vue&type=template&id=fa1f2dfa&scoped=true&", function () {
      api.rerender('fa1f2dfa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/Copy.vue"
export default component.exports